import styled from 'styled-components'

export const List = styled.div<{ $mt?: number }>`
  ${({ $mt }) => $mt && `margin-top: ${$mt}px;`}
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 1082px;
  margin-inline: auto;
`

export const Item = styled.div`
  position: relative;
  padding: 12px 8px;
  border-bottom: 1px solid #ccd6e0;

  .accordion-title {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    font-weight: 500;
    font-size: 16px;
    color: #1f2b36;
    cursor: pointer;

    .arrow {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      transition: transform 0.2s ease-out;
    }
  }

  .accordion-content {
    display: grid;
    grid-template-rows: 0fr;
    margin-top: 0;
    transition:
      grid-template-rows 0.2s ease-out,
      margin-top 0.2s ease-out;
    font-size: 16px;
    color: #1f2b36;
    white-space: pre-line;

    &-inner {
      overflow: hidden;
    }
  }

  .accordion-trigger {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
    overflow: hidden;
    clip: rect(0 0 0 0);

    &:focus-visible ~ .accordion-title {
      outline: 2px solid ${({ theme }) => theme.colors?.text};
      outline-offset: 2px;
    }

    &:checked {
      & ~ .accordion-title .arrow {
        transform: rotate(180deg);
      }

      & ~ .accordion-content {
        grid-template-rows: 1fr;
        margin-top: 8px;
      }
    }
  }
`
